import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/producto/${product.id}`}
      className="product-card group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-card-img aspect-[3/4] mb-4 relative">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-[#F9F6F0] text-[#1E1E1E] label-tracked px-3 py-1 text-[10px]">
            Pieza única
          </span>
        )}
      </div>
      <div className="px-1">
        <div className="label-tracked text-[#5C5C5C] mb-1">
          {product.category}
        </div>
        <h3 className="font-serif-editorial text-xl leading-tight group-hover:text-[#C27A62] transition-colors">
          {product.name}
        </h3>
        <div className="text-[#1E1E1E] mt-2 text-sm">
          €{product.price.toFixed(2)}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
